// import React, { useCallback, useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { useForm } from 'react-hook-form';
// import { addCompany } from '../../../redux/actions/company';
// import * as yup from 'yup';
// import { yupResolver } from '@hookform/resolvers/yup';
// import { getGroupIDs } from '../../../redux/actions/companyGroup';
// import { getCities } from '../../../redux/actions/city';
// import InputBox from 'components/inputBox/InputBox';
// import { getCompanyDetailsByGst } from '../../../redux/actions/company';
// import { useColorMode } from '@chakra-ui/react';

// const schema = yup
//    .object({
//       name: yup.string().required('Company Name is required'),
//       gstRegNo: yup.string().optional(),
//       panNo: yup
//          .string()
//          .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number format')
//          .required('PAN is required'),
//       mobile: yup.string().optional(),
//       email: yup.string().email('Invalid email format').optional(),
//       address1: yup.string().required('Address 1 is required'),
//       address2: yup.string().optional(),
//       address3: yup.string().optional(),
//       pincode: yup.string().optional(),
//       cityId: yup.string().required('City is required'),
//    })
//    .required();

// function CreateComp() {
//    const { colorMode, toggleColorMode } = useColorMode();
//    const isDark = colorMode === 'dark';
//    const [prevGstLength, setPrevGstLength] = useState(0);

//    const dispatch = useDispatch();
//    const navigate = useNavigate();
//    const coGroupIds = useSelector((state) => state.companyGroup.list);
//    const cities = useSelector((state) => state.city.list);
//    const company = useSelector((state) => state.company?.gstDetail);

//    useEffect(() => {
//       dispatch(getGroupIDs());
//    }, [dispatch]);

//    useEffect(() => {
//       dispatch(getCities());
//    }, [dispatch]);

//    const {
//       register,
//       handleSubmit,
//       control,
//       setValue,
//       formState: { errors, isSubmitting },
//    } = useForm({
//       resolver: yupResolver(schema),
//       mode: 'all',
//       defaultValues: {
//          name: '',
//          panNo: '',
//          gstRegNo: '',
//          mobile: '',
//          email: '',
//          address1: '',
//          address2: '',
//          address3: '',
//          cityId: '',
//          coGroupId: '',
//       },
//    });

//    useEffect(() => {
//       if (company) {
//          const address = company && company.pradr ? company.pradr.addr : {};

//          setValue('name', company?.tradeNam);
//          setValue('address1', `${address?.flno} ${address?.bno}, ${address?.bnm} ${address?.st}, ${address?.locality}`);
//          setValue('cityId', cities.find((city) => city?.name?.toLowerCase() === address?.dst?.toLowerCase())?.id);
//          setValue('pincode', address?.pncd);
//       }
//    }, [cities, company, setValue]);

//    const getCompanyDetailsByGST = useCallback(
//       async (gst) => {
//          await dispatch(getCompanyDetailsByGst(gst));
//       },
//       [dispatch],
//    );

//    const handleOnChange = (e) => {
//       const { value } = e.target;
//       const upperValue = value.toUpperCase();
//       const currentLength = upperValue?.toString()?.length || 0;

//       setValue('gstRegNo', upperValue);

//       if (currentLength === 15) {
//          setValue('panNo', upperValue?.slice(2, 12));
//       }

//       if (currentLength === 15 && prevGstLength < 15) {
//          getCompanyDetailsByGST(upperValue);
//       }

//       setPrevGstLength(currentLength);
//    };

//    const onSubmit = async (data) => {
//       delete data.city;
//       delete data.getRegNo;
//       dispatch(addCompany(navigate, data));
//    };

//    return (
//       <div
//          className={`min-h-screen relative overflow-hidden transition-all duration-700 ${
//             isDark
//                ? 'bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900'
//                : 'bg-gradient-to-br from-gray-50 via-blue-50/30 to-indigo-50/20'
//          }`}>
//          {/* Animated Background Elements */}
//          <div className="absolute inset-0 overflow-hidden pointer-events-none">
//             <div
//                className={`absolute -top-40 -right-40 w-96 h-96 rounded-full blur-3xl opacity-20 ${
//                   isDark ? 'bg-blue-600' : 'bg-blue-400'
//                }`}></div>
//             <div
//                className={`absolute -bottom-40 -left-40 w-96 h-96 rounded-full blur-3xl opacity-20 ${
//                   isDark ? 'bg-purple-600' : 'bg-purple-400'
//                }`}></div>
//             <div
//                className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full blur-3xl opacity-10 ${
//                   isDark ? 'bg-indigo-600' : 'bg-indigo-300'
//                }`}></div>
//          </div>

//          {/* Theme Toggle Button */}
//          <div className="fixed top-8 right-8 z-50">
//             <button
//                onClick={toggleColorMode}
//                className={`group relative p-4 rounded-2xl transition-all duration-500 transform hover:scale-110 hover:rotate-12 active:scale-95 ${
//                   isDark
//                      ? 'bg-gray-800/80 backdrop-blur-xl border-2 border-gray-700/50 shadow-2xl shadow-blue-500/20'
//                      : 'bg-white/90 backdrop-blur-xl border-2 border-gray-200/50 shadow-2xl shadow-indigo-200/50'
//                }`}>
//                <div className="relative">
//                   {isDark ? (
//                      <svg
//                         className="w-6 h-6 text-yellow-400 transition-transform duration-500 group-hover:rotate-180"
//                         fill="currentColor"
//                         viewBox="0 0 20 20">
//                         <path
//                            fillRule="evenodd"
//                            d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
//                            clipRule="evenodd"
//                         />
//                      </svg>
//                   ) : (
//                      <svg
//                         className="w-6 h-6 text-indigo-600 transition-transform duration-500 group-hover:-rotate-45"
//                         fill="currentColor"
//                         viewBox="0 0 20 20">
//                         <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
//                      </svg>
//                   )}
//                </div>
//             </button>
//          </div>

//          {/* Main Content */}
//          <div className="relative z-10 container mx-auto px-4 py-12 lg:py-10">
//             <div className="max-w-5xl mx-auto">
//                {/* Main Card */}
//                <div
//                   className={`rounded-3xl overflow-hidden transition-all duration-700 backdrop-blur-2xl ${
//                      isDark
//                         ? 'bg-gray-800/40 border-2 border-gray-700/30 shadow-2xl shadow-black/20'
//                         : 'bg-white/70 border-2 border-white/60 shadow-2xl shadow-gray-200/50'
//                   }`}>
//                   {/* Header Section */}
//                   <div
//                      className={`relative px-8 md:px-12 pt-4 pb-4 ${
//                         isDark
//                            ? 'bg-gradient-to-r from-blue-600/20 via-purple-600/20 to-indigo-600/20 border-b-2 border-gray-700/30'
//                            : 'bg-gradient-to-r from-blue-50/80 via-indigo-50/80 to-purple-50/80 border-b-2 border-gray-100/80'
//                      }`}>
//                      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
//                         <div className="flex items-center gap-6">
//                            <div
//                               className={`relative p-2 rounded-2xl ${
//                                  isDark
//                                     ? 'bg-gradient-to-br from-blue-500 to-purple-600 shadow-lg shadow-blue-500/30'
//                                     : 'bg-gradient-to-br from-blue-500 to-indigo-600 shadow-xl shadow-blue-300/40'
//                               }`}>
//                               <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                  <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2.5}
//                                     d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
//                                  />
//                               </svg>
//                               <div
//                                  className={`absolute inset-0 rounded-2xl opacity-50 blur-xl ${
//                                     isDark ? 'bg-blue-500' : 'bg-blue-400'
//                                  }`}></div>
//                            </div>
//                            <div>
//                               <h1
//                                  className={`text-xl md:text-2xl font-bold mb-0.5 ${
//                                     isDark ? 'text-white' : 'text-gray-900'
//                                  }`}>
//                                  Create New Company
//                               </h1>
//                               <p className={`text-sm md:text-md ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
//                                  Set up your company profile in minutes
//                               </p>
//                            </div>
//                         </div>
//                      </div>
//                   </div>

//                   {/* Form Content */}
//                   <form onSubmit={handleSubmit(onSubmit)} className="p-4 md:p-6 space-y-10">
//                      {/* Company Information Section */}
//                      <div
//                         className={`rounded-2xl p-4 transition-all duration-500 ${
//                            isDark
//                               ? 'bg-gradient-to-br from-blue-900/20 to-blue-800/10 border-2 border-blue-700/30'
//                               : 'bg-gradient-to-br from-blue-50/50 to-indigo-50/30 border-2 border-blue-100/50'
//                         }`}>
//                         <div className="flex items-center gap-4 mb-4">
//                            <div
//                               className={`relative p-2 rounded-xl ${
//                                  isDark
//                                     ? 'bg-blue-500/20 border-2 border-blue-500/40'
//                                     : 'bg-blue-500/10 border-2 border-blue-300/50'
//                               }`}>
//                               <svg
//                                  className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-blue-600'}`}
//                                  fill="none"
//                                  stroke="currentColor"
//                                  viewBox="0 0 24 24">
//                                  <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2}
//                                     d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
//                                  />
//                               </svg>
//                            </div>
//                            <div>
//                               <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
//                                  Company Information
//                               </h2>
//                               <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
//                                  Basic details about your company
//                               </p>
//                            </div>
//                         </div>

//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                            <div className="transform transition-all duration-300 hover:scale-[1.02]">
//                               <InputBox
//                                  name="gstRegNo"
//                                  label="GST NO"
//                                  control={control}
//                                  register={register}
//                                  type="text"
//                                  placeholder="Enter GST NO"
//                                  onChange={handleOnChange}
//                                  maxLength={15}
//                                  style={{ textTransform: 'uppercase' }}
//                                  errors={errors}
//                               />
//                            </div>
//                            <div className="transform transition-all duration-300 hover:scale-[1.02]">
//                               <InputBox
//                                  name="name"
//                                  label="Company Name"
//                                  control={control}
//                                  register={register}
//                                  type="text"
//                                  placeholder="Enter company name"
//                                  errors={errors}
//                               />
//                            </div>
//                            <div className="transform transition-all duration-300 hover:scale-[1.02]">
//                               <InputBox
//                                  name="panNo"
//                                  label="PAN"
//                                  control={control}
//                                  register={register}
//                                  type="text"
//                                  placeholder="Enter PAN No"
//                                  style={{ textTransform: 'uppercase' }}
//                                  errors={errors}
//                               />
//                            </div>
//                            <div className="transform transition-all duration-300 hover:scale-[1.02]">
//                               <InputBox
//                                  name="mobile"
//                                  label="Mobile"
//                                  control={control}
//                                  register={register}
//                                  type="text"
//                                  placeholder="Enter mobile"
//                                  errors={errors}
//                               />
//                            </div>
//                         </div>

//                         <div className=" transform transition-all duration-300 hover:scale-[1.01]">
//                            <InputBox
//                               name="email"
//                               label="Email"
//                               control={control}
//                               register={register}
//                               type="text"
//                               placeholder="Enter email"
//                               errors={errors}
//                            />
//                         </div>
//                      </div>

//                      {/* Address Information Section */}
//                      <div
//                         className={`rounded-2xl p-4 transition-all duration-500 ${
//                            isDark
//                               ? 'bg-gradient-to-br from-purple-900/20 to-purple-800/10 border-2 border-purple-700/30'
//                               : 'bg-gradient-to-br from-purple-50/50 to-pink-50/30 border-2 border-purple-100/50'
//                         }`}>
//                         <div className="flex items-center gap-4 mb-4">
//                            <div
//                               className={`relative p-2 rounded-xl ${
//                                  isDark
//                                     ? 'bg-purple-500/20 border-2 border-purple-500/40'
//                                     : 'bg-purple-500/10 border-2 border-purple-300/50'
//                               }`}>
//                               <svg
//                                  className={`w-5 h-5 ${isDark ? 'text-purple-400' : 'text-purple-600'}`}
//                                  fill="none"
//                                  stroke="currentColor"
//                                  viewBox="0 0 24 24">
//                                  <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2}
//                                     d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
//                                  />
//                                  <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2}
//                                     d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
//                                  />
//                               </svg>
//                            </div>
//                            <div>
//                               <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
//                                  Address Details
//                               </h2>
//                               <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
//                                  Where is your company located?
//                               </p>
//                            </div>
//                         </div>

//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                            <div className="transform transition-all duration-300 hover:scale-[1.02]">
//                               <InputBox
//                                  name="address1"
//                                  label="Address 1"
//                                  control={control}
//                                  register={register}
//                                  type="text"
//                                  placeholder="Enter address 1"
//                                  errors={errors}
//                               />
//                            </div>
//                            <div className="transform transition-all duration-300 hover:scale-[1.02]">
//                               <InputBox
//                                  name="address2"
//                                  label="Address 2"
//                                  control={control}
//                                  register={register}
//                                  type="text"
//                                  placeholder="Enter address 2"
//                                  errors={errors}
//                               />
//                            </div>

//                            <div className="transform transition-all duration-300 hover:scale-[1.02]">
//                               <InputBox
//                                  name="address3"
//                                  label="Address 3"
//                                  control={control}
//                                  register={register}
//                                  type="text"
//                                  placeholder="Enter address 3"
//                                  errors={errors}
//                               />
//                            </div>
//                            <div className="transform transition-all duration-300 hover:scale-[1.02]">
//                               <InputBox
//                                  name="pincode"
//                                  label="Pincode"
//                                  control={control}
//                                  register={register}
//                                  type="text"
//                                  placeholder="Enter pincode"
//                                  errors={errors}
//                               />
//                            </div>
//                            <div className="transform transition-all duration-300 hover:scale-[1.02]"></div>
//                         </div>

//                         <div className=" grid grid-cols-1 md:grid-cols-2 gap-6">
//                            <div>
//                               <label
//                                  className={`block text-sm font-bold mb-1 ${
//                                     isDark ? 'text-gray-200' : 'text-gray-800'
//                                  }`}>
//                                  City <span className="text-red-500">*</span>
//                               </label>
//                               <div className="relative">
//                                  <select
//                                     {...register('cityId')}
//                                     className={`w-full px-5 py-2 rounded-xl border-2 transition-all duration-300 focus:outline-none focus:ring-4 appearance-none cursor-pointer font-medium ${
//                                        errors.cityId
//                                           ? 'border-red-500 focus:ring-red-500/20 focus:border-red-500'
//                                           : isDark
//                                           ? 'bg-gray-800/50 border-gray-600/50 text-white focus:border-purple-500 focus:ring-purple-500/20 hover:border-purple-500/50'
//                                           : 'bg-white/80 border-gray-300 text-gray-900 focus:border-purple-500 focus:ring-purple-500/20 hover:border-purple-400'
//                                     }`}>
//                                     <option value="">Select city</option>
//                                     {cities.map((city) => (
//                                        <option key={city.id} value={city.id}>
//                                           {city.name}
//                                        </option>
//                                     ))}
//                                  </select>
//                                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
//                                     <svg
//                                        className={`w-5 h-5 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}
//                                        fill="none"
//                                        stroke="currentColor"
//                                        viewBox="0 0 24 24">
//                                        <path
//                                           strokeLinecap="round"
//                                           strokeLinejoin="round"
//                                           strokeWidth={2}
//                                           d="M19 9l-7 7-7-7"
//                                        />
//                                     </svg>
//                                  </div>
//                               </div>
//                               {errors.cityId && (
//                                  <p className="text-red-500 text-sm mt-2 font-semibold">{errors.cityId.message}</p>
//                               )}
//                            </div>

//                            {coGroupIds && coGroupIds.length > 0 && (
//                               <div className="transform transition-all duration-300 hover:scale-[1.02]">
//                                  <div>
//                                     <label
//                                        className={`block text-sm font-bold mb-1 ${
//                                           isDark ? 'text-gray-200' : 'text-gray-800'
//                                        }`}>
//                                        Group ID
//                                     </label>
//                                     <div className="relative">
//                                        <select
//                                           {...register('coGroupId')}
//                                           className={`w-full px-5 py-2 rounded-xl border-2 transition-all duration-300 focus:outline-none focus:ring-4 appearance-none cursor-pointer font-medium ${
//                                              errors.coGroupId
//                                                 ? 'border-red-500 focus:ring-red-500/20 focus:border-red-500'
//                                                 : isDark
//                                                 ? 'bg-gray-800/50 border-gray-600/50 text-white focus:border-purple-500 focus:ring-purple-500/20 hover:border-purple-500/50'
//                                                 : 'bg-white/80 border-gray-300 text-gray-900 focus:border-purple-500 focus:ring-purple-500/20 hover:border-purple-400'
//                                           }`}>
//                                           <option value="">Select Group ID</option>
//                                           {coGroupIds.map((group) => (
//                                              <option key={group.id} value={group.id}>
//                                                 {group.name}
//                                              </option>
//                                           ))}
//                                        </select>
//                                        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
//                                           <svg
//                                              className={`w-5 h-5 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}
//                                              fill="none"
//                                              stroke="currentColor"
//                                              viewBox="0 0 24 24">
//                                              <path
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                                 strokeWidth={2}
//                                                 d="M19 9l-7 7-7-7"
//                                              />
//                                           </svg>
//                                        </div>
//                                     </div>
//                                     {errors.coGroupId && (
//                                        <p className="text-red-500 text-sm mt-2 font-semibold">
//                                           {errors.coGroupId.message}
//                                        </p>
//                                     )}
//                                  </div>
//                               </div>
//                            )}
//                         </div>
//                      </div>

//                      {/* Submit Button */}
//                      <div className="">
//                         <button
//                            type="submit"
//                            disabled={isSubmitting}
//                            className={`group relative py-3 px-10 rounded-2xl font-bold text-lg transition-all duration-500 transform overflow-hidden ${
//                               isSubmitting
//                                  ? 'bg-gray-400 cursor-not-allowed'
//                                  : isDark
//                                  ? 'bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 hover:from-blue-500 hover:via-purple-500 hover:to-indigo-500 text-white shadow-2xl shadow-blue-500/30 hover:shadow-purple-500/40 hover:scale-[1.02] active:scale-[0.98]'
//                                  : 'bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 hover:from-blue-700 hover:via-indigo-700 hover:to-purple-700 text-white shadow-2xl shadow-indigo-300/50 hover:shadow-indigo-400/60 hover:scale-[1.02] active:scale-[0.98]'
//                            }`}>
//                            <span className="relative z-10 flex items-center justify-center gap-3">
//                               {isSubmitting ? (
//                                  <>
//                                     <svg className="animate-spin h-6 w-6" viewBox="0 0 24 24">
//                                        <circle
//                                           className="opacity-25"
//                                           cx="12"
//                                           cy="12"
//                                           r="10"
//                                           stroke="currentColor"
//                                           strokeWidth="4"
//                                           fill="none"
//                                        />
//                                        <path
//                                           className="opacity-75"
//                                           fill="currentColor"
//                                           d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                                        />
//                                     </svg>
//                                     <span>Creating Company...</span>
//                                  </>
//                               ) : (
//                                  <>
//                                     <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                        <path
//                                           strokeLinecap="round"
//                                           strokeLinejoin="round"
//                                           strokeWidth={2.5}
//                                           d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//                                        />
//                                     </svg>
//                                     <span>Create Company</span>
//                                     <svg
//                                        className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300"
//                                        fill="none"
//                                        stroke="currentColor"
//                                        viewBox="0 0 24 24">
//                                        <path
//                                           strokeLinecap="round"
//                                           strokeLinejoin="round"
//                                           strokeWidth={2.5}
//                                           d="M13 7l5 5m0 0l-5 5m5-5H6"
//                                        />
//                                     </svg>
//                                  </>
//                               )}
//                            </span>
//                         </button>
//                      </div>
//                   </form>
//                </div>
//             </div>
//          </div>
//       </div>
//    );
// }

// export default CreateComp;

import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { addCompany } from '../../../redux/actions/company';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { getGroupIDs } from '../../../redux/actions/companyGroup';
import { getCities } from '../../../redux/actions/city';
import InputBox from 'components/inputBox/InputBox';
import { getCompanyDetailsByGst } from '../../../redux/actions/company';
import { useColorMode } from '@chakra-ui/react';

const schema = yup
   .object({
      name: yup.string().required('Company Name is required'),
      gstRegNo: yup.string().optional(),
      panNo: yup
         .string()
         .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number format')
         .required('PAN is required'),
      mobile: yup.string().optional(),
      email: yup.string().email('Invalid email format').optional(),
      address1: yup.string().required('Address 1 is required'),
      address2: yup.string().optional(),
      address3: yup.string().optional(),
      pincode: yup.string().optional(),
      cityId: yup.string().required('City is required'),
   })
   .required();

function CreateComp() {
   const { colorMode, toggleColorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [prevGstLength, setPrevGstLength] = useState(0);

   const dispatch = useDispatch();
   const navigate = useNavigate();
   const coGroupIds = useSelector((state) => state.companyGroup.list);
   const cities = useSelector((state) => state.city.list);
   const company = useSelector((state) => state.company?.gstDetail);

   useEffect(() => {
      dispatch(getGroupIDs());
   }, [dispatch]);

   useEffect(() => {
      dispatch(getCities());
   }, [dispatch]);

   const {
      register,
      handleSubmit,
      control,
      setValue,
      formState: { errors, isSubmitting },
   } = useForm({
      resolver: yupResolver(schema),
      mode: 'all',
      defaultValues: {
         name: '',
         panNo: '',
         gstRegNo: '',
         mobile: '',
         email: '',
         address1: '',
         address2: '',
         address3: '',
         cityId: '',
         coGroupId: '',
      },
   });

   useEffect(() => {
      if (company) {
         const address = company && company.pradr ? company.pradr.addr : {};
         setValue('name', company?.tradeNam);
         setValue('address1', `${address?.flno} ${address?.bno}, ${address?.bnm} ${address?.st}, ${address?.locality}`);
         setValue('cityId', cities.find((city) => city?.name?.toLowerCase() === address?.dst?.toLowerCase())?.id);
         setValue('pincode', address?.pncd);
      }
   }, [cities, company, setValue]);

   const getCompanyDetailsByGST = useCallback(
      async (gst) => {
         await dispatch(getCompanyDetailsByGst(gst));
      },
      [dispatch],
   );

   const handleOnChange = (e) => {
      const { value } = e.target;
      const upperValue = value.toUpperCase();
      const currentLength = upperValue?.toString()?.length || 0;

      setValue('gstRegNo', upperValue);

      if (currentLength === 15) {
         setValue('panNo', upperValue?.slice(2, 12));
      }

      if (currentLength === 15 && prevGstLength < 15) {
         getCompanyDetailsByGST(upperValue);
      }

      setPrevGstLength(currentLength);
   };

   const onSubmit = async (data) => {
      delete data.city;
      delete data.getRegNo;
      dispatch(addCompany(navigate, data));
   };

   return (
      <div className={`min-h-screen ${isDark ? 'bg-slate-950' : 'bg-gray-50'}`}>
         {/* Theme Toggle */}
         <button
            onClick={toggleColorMode}
            className={`fixed top-6 right-6 z-50 p-3 rounded-full transition-all ${
               isDark
                  ? 'bg-yellow-500/10 text-yellow-400 hover:bg-yellow-500/20 border border-yellow-500/30'
                  : 'bg-indigo-100 text-indigo-700 hover:bg-indigo-200 border border-indigo-200'
            }`}>
            {isDark ? (
               <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path
                     fillRule="evenodd"
                     d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                     clipRule="evenodd"
                  />
               </svg>
            ) : (
               <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
               </svg>
            )}
         </button>

         {/* Side Navigation */}
         <div
            className={`fixed left-0 top-0 h-screen w-20 flex flex-col items-center py-8 ${
               isDark ? 'bg-slate-900 border-r border-slate-800' : 'bg-white border-r border-gray-200'
            }`}>
            <div
               className={`w-12 h-12 rounded-xl flex items-center justify-center mb-12 ${
                  isDark ? 'bg-emerald-500/20 text-emerald-400' : 'bg-emerald-100 text-emerald-600'
               }`}>
               <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth={2}
                     d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
               </svg>
            </div>
         </div>

         {/* Main Content */}
         <div className="ml-20 p-6">
            <div className="max-w-6xl mx-auto">
               {/* Page Title */}
               <div className="mb-4">
                  <h1 className={`text-4xl font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
                     Create New Company
                  </h1>
                  <p className={`text-lg ${isDark ? 'text-slate-400' : 'text-gray-600'}`}>
                     Fill in the information below to register your company
                  </p>
               </div>

               <div onSubmit={handleSubmit(onSubmit)}>
                  <div className="grid grid-cols-12 gap-6">
                     {/* Left - Company Info */}
                     <div className="col-span-7">
                        <div
                           className={`rounded-2xl py-4 px-6 ${
                              isDark
                                 ? 'bg-slate-900 border-l-4 border-emerald-500'
                                 : 'bg-white border-l-4 border-emerald-500 shadow-sm'
                           }`}>
                           {/* Header */}
                           <div
                              className="flex items-center gap-4 pb-6 mb-3 border-b border-dashed"
                              style={{ borderColor: isDark ? 'rgb(51 65 85)' : 'rgb(229 231 235)' }}>
                              <div
                                 className={`w-12 h-12 rounded-2xl flex items-center justify-center ${
                                    isDark ? 'bg-emerald-500/10' : 'bg-emerald-50'
                                 }`}>
                                 <svg
                                    className={`w-6 h-6 ${isDark ? 'text-emerald-400' : 'text-emerald-600'}`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                       strokeWidth={2}
                                       d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                    />
                                 </svg>
                              </div>
                              <div>
                                 <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                                    Company Information
                                 </h2>
                                 <p className={`text-sm ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>
                                    Primary business details
                                 </p>
                              </div>
                           </div>

                           <div className="space-y-2">
                              <InputBox
                                 name="gstRegNo"
                                 label="GST NO"
                                 control={control}
                                 register={register}
                                 type="text"
                                 placeholder="Enter GST Number"
                                 onChange={handleOnChange}
                                 maxLength={15}
                                 style={{ textTransform: 'uppercase' }}
                                 errors={errors}
                              />

                              <InputBox
                                 name="name"
                                 label="Company Name"
                                 control={control}
                                 register={register}
                                 type="text"
                                 placeholder="Enter your company name"
                                 errors={errors}
                              />

                              <div className="grid grid-cols-2 gap-5">
                                 <InputBox
                                    name="panNo"
                                    label="PAN"
                                    control={control}
                                    register={register}
                                    type="text"
                                    placeholder="PAN Number"
                                    style={{ textTransform: 'uppercase' }}
                                    errors={errors}
                                 />

                                 <InputBox
                                    name="mobile"
                                    label="Mobile"
                                    control={control}
                                    register={register}
                                    type="text"
                                    placeholder="Contact number"
                                    errors={errors}
                                 />
                              </div>

                              <InputBox
                                 name="email"
                                 label="Email"
                                 control={control}
                                 register={register}
                                 type="text"
                                 placeholder="company@example.com"
                                 errors={errors}
                              />
                           </div>
                        </div>
                     </div>

                     {/* Right - Address Info */}
                     <div className="col-span-5">
                        <div
                           className={`rounded-2xl py-5 px-6 ${
                              isDark
                                 ? 'bg-slate-900 border-l-4 border-violet-500'
                                 : 'bg-white border-l-4 border-violet-500 shadow-sm'
                           }`}>
                           <div
                              className="flex items-center gap-4 pb-6 mb-3 border-b border-dashed"
                              style={{ borderColor: isDark ? 'rgb(51 65 85)' : 'rgb(229 231 235)' }}>
                              <div
                                 className={`w-12 h-12 rounded-2xl flex items-center justify-center ${
                                    isDark ? 'bg-violet-500/10' : 'bg-violet-50'
                                 }`}>
                                 <svg
                                    className={`w-6 h-6 ${isDark ? 'text-violet-400' : 'text-violet-600'}`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                       strokeWidth={2}
                                       d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                    />
                                    <path
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                       strokeWidth={2}
                                       d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                 </svg>
                              </div>
                              <div>
                                 <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                                    Address
                                 </h2>
                                 <p className={`text-sm ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>
                                    Location details
                                 </p>
                              </div>
                           </div>

                           <div className="space-y-2">
                              <InputBox
                                 name="address1"
                                 label="Address 1"
                                 control={control}
                                 register={register}
                                 type="text"
                                 placeholder="Street address"
                                 errors={errors}
                              />

                              <InputBox
                                 name="address2"
                                 label="Address 2"
                                 control={control}
                                 register={register}
                                 type="text"
                                 placeholder="Apartment, suite, etc."
                                 errors={errors}
                              />

                              <InputBox
                                 name="address3"
                                 label="Address 3"
                                 control={control}
                                 register={register}
                                 type="text"
                                 placeholder="Additional info"
                                 errors={errors}
                              />

                              <InputBox
                                 name="pincode"
                                 label="Pincode"
                                 control={control}
                                 register={register}
                                 type="text"
                                 placeholder="Enter pincode"
                                 errors={errors}
                              />

                              <div>
                                 <label
                                    className={`block text-sm font-semibold mb-2 ${
                                       isDark ? 'text-slate-200' : 'text-gray-800'
                                    }`}>
                                    City <span className="text-red-500">*</span>
                                 </label>
                                 <div className="relative">
                                    <select
                                       {...register('cityId')}
                                       className={`w-full px-4 py-2.5 rounded-lg border transition-all focus:outline-none focus:ring-2 appearance-none ${
                                          errors.cityId
                                             ? 'border-red-500 focus:ring-red-500/20'
                                             : isDark
                                             ? 'bg-slate-800 border-slate-700 text-white focus:border-violet-500 focus:ring-violet-500/20'
                                             : 'bg-white border-gray-300 text-gray-900 focus:border-violet-500 focus:ring-violet-500/20'
                                       }`}>
                                       <option value="">Select city</option>
                                       {cities.map((city) => (
                                          <option key={city.id} value={city.id}>
                                             {city.name}
                                          </option>
                                       ))}
                                    </select>
                                    <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                                       <svg
                                          className={`w-5 h-5 ${isDark ? 'text-slate-400' : 'text-gray-500'}`}
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M19 9l-7 7-7-7"
                                          />
                                       </svg>
                                    </div>
                                 </div>
                                 {errors.cityId && (
                                    <p className="text-red-500 text-sm mt-1.5">{errors.cityId.message}</p>
                                 )}
                              </div>

                              {coGroupIds && coGroupIds.length > 0 && (
                                 <div>
                                    <label
                                       className={`block text-sm font-semibold mb-2 ${
                                          isDark ? 'text-slate-200' : 'text-gray-800'
                                       }`}>
                                       Group ID
                                    </label>
                                    <div className="relative">
                                       <select
                                          {...register('coGroupId')}
                                          className={`w-full px-4 py-2.5 rounded-lg border transition-all focus:outline-none focus:ring-2 appearance-none ${
                                             isDark
                                                ? 'bg-slate-800 border-slate-700 text-white focus:border-violet-500 focus:ring-violet-500/20'
                                                : 'bg-white border-gray-300 text-gray-900 focus:border-violet-500 focus:ring-violet-500/20'
                                          }`}>
                                          <option value="">Select Group ID</option>
                                          {coGroupIds.map((group) => (
                                             <option key={group.id} value={group.id}>
                                                {group.name}
                                             </option>
                                          ))}
                                       </select>
                                       <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                                          <svg
                                             className={`w-5 h-5 ${isDark ? 'text-slate-400' : 'text-gray-500'}`}
                                             fill="none"
                                             stroke="currentColor"
                                             viewBox="0 0 24 24">
                                             <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M19 9l-7 7-7-7"
                                             />
                                          </svg>
                                       </div>
                                    </div>
                                 </div>
                              )}
                           </div>
                        </div>
                     </div>

                     {/* Submit Section */}
                     <div className="col-span-12">
                        <div
                           className={`rounded-2xl py-4 px-6 flex items-center justify-between ${
                              isDark ? 'bg-slate-900' : 'bg-white shadow-sm'
                           }`}>
                           <div>
                              <p className={`text-sm ${isDark ? 'text-slate-400' : 'text-gray-600'}`}>
                                 By creating a company, you agree to our terms and conditions
                              </p>
                           </div>
                           <button
                              type="button"
                              onClick={handleSubmit(onSubmit)}
                              disabled={isSubmitting}
                              className={`px-8 py-3 rounded-xl font-semibold text-white transition-all flex items-center gap-3 ${
                                 isSubmitting
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : isDark
                                    ? 'bg-emerald-500 hover:bg-emerald-600 shadow-lg shadow-emerald-500/30'
                                    : 'bg-emerald-500 hover:bg-emerald-600 shadow-lg shadow-emerald-500/40'
                              }`}>
                              {isSubmitting ? (
                                 <>
                                    <svg
                                       className="animate-spin h-5 w-5"
                                       viewBox="0 0 24 24"
                                       fill="none"
                                       stroke="currentColor">
                                       <circle className="opacity-25" cx="12" cy="12" r="10" strokeWidth="4" />
                                       <path
                                          className="opacity-75"
                                          fill="currentColor"
                                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                       />
                                    </svg>
                                    Creating...
                                 </>
                              ) : (
                                 <>
                                    Create Company
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                       <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M13 7l5 5m0 0l-5 5m5-5H6"
                                       />
                                    </svg>
                                 </>
                              )}
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}

export default CreateComp;
